import React, { useEffect, useState } from 'react'
import { Popover, Checkbox, Tree } from 'antd'
import { formatMessageNew, uniqueFun } from '@/utils/common'
import { useSelector } from 'react-redux'
// import { SettingOutlined } from '@ant-design/icons'
import { ReactComponent as SettingPng } from '@/assets/images/setting.svg'
import { ReactComponent as SettingHPng } from '@/assets/images/setting_h.svg'
const AntdTableOptPage = props => {
  let tableColumnsValues = []
  let tableColumnsParentValues = []
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const { columns, tableColumns, columnsChange } = props
  const flattenDataFun = (arr, resLs = []) => {
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      if (element.children) {
        tableColumnsParentValues.push(element.dataIndex)
        resLs.push(element)
        flattenDataFun(element.children, resLs)
      } else {
        resLs.push(element)
      }
    }
    return resLs
  }
  const getDefaultVFun = ls => {
    const flattenedDeep = flattenDataFun(ls)
    return flattenedDeep
      .map(itemMap => {
        return itemMap.key || itemMap.dataIndex
      })
      .filter(Boolean)
  }
  const getDefaultVNotHalfFun = () => {
    tableColumnsValues = getDefaultVFun(tableColumns)
    let resValues = tableColumnsValues
    if (tableColumnsParentValues && tableColumnsParentValues.length > 0) {
      resValues = tableColumnsValues.filter(item => {
        if (!tableColumnsParentValues.includes(item)) {
          return item
        } else {
          return null
        }
      })
    }
    return resValues.filter(Boolean)
  }
  const allDataIndex = getDefaultVFun(columns)
  tableColumnsParentValues = []
  const defaultV = getDefaultVNotHalfFun()
  const [checkAll, setCheckAll] = useState(true)
  useEffect(() => {
    let defCheckAll = tableColumnsValues.length === allDataIndex.length ? true : false
    setCheckAll(defCheckAll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableColumns])
  const onCheck = (checkedKeysValue, e) => {
    let hasHalfKeys = e.halfCheckedKeys || []
    let values = [...checkedKeysValue, ...hasHalfKeys]
    columnsChange && columnsChange(uniqueFun(values, 2))
  }
  const content = (
    <div>
      <Tree
        checkable
        defaultExpandAll={true}
        multiple={true}
        treeData={columns}
        fieldNames={{ title: 'title', key: 'dataIndex', children: 'children' }}
        checkedKeys={defaultV}
        selectedKeys={defaultV}
        onCheck={onCheck}
      />
      {/* <Checkbox.Group
        style={{
          width: '100%',
          display: 'block',
          maxHeightheight: '300px',
          overflow: 'auto'
        }}
        value={defaultV}
        onChange={value => {
          columnsChange && columnsChange(value)
        }}
      >
        {columns.map((item, idx) => {
          return (
            <div
              style={{
                padding: '5px 10px'
              }}
              key={idx}
            >
              <Checkbox value={item.dataIndex}>{item.title}</Checkbox>
            </div>
          )
        })}
      </Checkbox.Group> */}
    </div>
  )

  const onCheckAllChange = () => {
    let checkA = !checkAll
    let dtIdxs = []
    if (!checkAll) {
      dtIdxs = allDataIndex
    }
    setCheckAll(checkA)
    columnsChange && columnsChange(dtIdxs)
  }
  const contentSelAll = (
    <div
      style={{
        padding: '5px 10px 10px',
        borderBottom: '1px solid #ccc'
      }}
    >
      <Checkbox
        checked={checkAll}
        onChange={() => {
          onCheckAllChange()
        }}
      >
        {formatMessageNew('languageObj.commonLocale.columnsSettingTitle')}
      </Checkbox>
    </div>
  )
  return (
    <Popover
      overlayClassName="my_popover"
      placement="leftBottom"
      content={content}
      title={contentSelAll}
      trigger="click"
    >
      <div className="cursorPointer">
        {!checkAll ? (
          <SettingPng
            style={{
              height: deviceSize * 20 * 1.15,
              width: deviceSize * 20 * 1.15
            }}
          />
        ) : (
          <SettingHPng
            style={{
              height: deviceSize * 20 * 1.15,
              width: deviceSize * 20 * 1.15
            }}
          />
        )}
      </div>
      {/* <SettingOutlined
          style={{
            fontSize: settingSize
          }}
        /> */}
    </Popover>
  )
}
export default AntdTableOptPage
